import { selectConsentCategories } from 'flow/selectors/app-selectors';

export type ConsentCategories = {
    analytics: boolean;
    errorMonitoring: boolean;
};

export const categoriesFromRedux = (
    consentCategories: ReturnType<typeof selectConsentCategories>,
): ConsentCategories => ({
    analytics: consentCategories?.get('analytics') === true,
    errorMonitoring: consentCategories?.get('errorMonitoring') === true,
});
